  import { Helmet } from 'react-helmet-async';
import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import {
  PageTitleWrapper,
  PageHeader,
  showErrorMessage,
  showSuccessMessage,
  Select,
  Tables,
  Button,
  TextField,
  CustomForm
} from '../../shared/components/index';
import {
  Grid,
  Container,
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  CardContent,
  CardActions,
  Box
} from '@mui/material';
import { useEffect, useState, MouseEvent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as bookingService from './services/bookingManagement.service';
import * as assetGroupService from 'src/modules/Asset-group/services/asset-groupManagement.service';
import { selectUserState } from 'src/auth/login/services/userSlice';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useTranslation } from 'react-i18next';
import {
  BookingStatus,
  Status,
  I18N,
  LIST_VIEW,
  PAYMENT_METHOD,
} from '../../shared/constants/constants';
import { useNavigate } from 'react-router';
import * as assetService from '../../modules/Asset/services/assetManagement.service';
import * as ROUTES from '../../shared/constants/routes';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import TableRowsTwoToneIcon from '@mui/icons-material/TableRowsTwoTone';
import { VIEW_TYPE } from './utils/utils';
import { useLocation, useSearchParams } from 'react-router-dom';
import backgroundImg from '../../assets/images/invoice/lado-ladi-invoice.png';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { DepositeStatus } from './models';
import { FormFieldType } from 'src/shared/components/form-field/service/formFieldInterface';


const BookingDetails = () => {
  const [selectedTab, setSelectedTab] = useState<string | null>(
    LIST_VIEW.TABLE_VIEW
  );
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [viewType, setViewType] = useState<string>(VIEW_TYPE.BOOKING_MANAGEMENT);
  const [isAddModal, setIsAddModal] = useState<boolean>(true);
  const [viewMode, setViewMode] = useState<string>(VIEW_TYPE.VIEW_BOOKING);
  const { t } = useTranslation(I18N.DEFAULT);
  const dispatch = useDispatch<any>();
  const [bookingList, setBookingList] = useState([]);
  const {
    tenantAssetList
  } = useSelector(assetService.selectorAssetState);
  const {
    bookingData,
    selectedBokingData,
    booking,
    isBookingUpdated,
    isError,
    errorMessage,
  } = useSelector(bookingService.selectorBookingManagementState);
  const { selectedOrganization, loginUserRole } = useSelector(selectUserState);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [bookingId, setBookingId] = useState(null);
  const [breadcrumbsHeading, setBreadcrumbsHeading] = useState(t('booking-d-lite'));
  const [headerSubtitle, setHeaderSubtitle] = useState(t('booking-d-lite'));
  const [fullBookingObj, setFullBookingObj] = useState(null);

  const {
    assetGroupData
  } = useSelector(assetGroupService.selectorAssetGroupState);
  const [isRentButtonDisabled, setIsRentButtonDisabled] = useState(false);
  const [pendingRent, setPendingRent] = useState(null);
  const [pendingRentPaymentType, setPendingRentPaymentType] = useState(PAYMENT_METHOD[1].id);

  const [depositeAmount, setDepositeAmount] = useState(null);
  const [depositeAmountPaymentMethod, setDepositeAmountPaymentMethod] = useState(PAYMENT_METHOD[1].id);

  const location = useLocation();
  const [params] = useSearchParams();
  const [initialValues, setInitialValues] = useState({
    rent: '',
    id: '',
    advance: '',
    depositeStatus: '',
    depositeAmount: '',
    bookingStatus: ''
  });

  useEffect(() => {
    findDefaultData();
  }, []);

  useEffect(() => {
    if (isBookingUpdated) {
      dispatch(bookingService.setIsBookingUpdated(false));
      if (viewMode === VIEW_TYPE.CANCEL_BOOKING) {
        setViewMode(VIEW_TYPE.VIEW_BOOKING);
        return showSuccessMessage('Booking Updated!', {
          theme: 'colored',
          position: 'top-right',
          autoClose: 5000
        });
      }
    }
  }, [isBookingUpdated]);

  useEffect(() => {
    if (isError) {
      dispatch(bookingService.setIsError(false));
      if (errorMessage !== '') {
        return showErrorMessage(errorMessage, {
          theme: 'colored',
          position: 'top-right',
          autoClose: 5000
        });
      }
    }
  }, [isError]);

  function handleOnStatusChange(event: any, bookingAsset: any) {
    const payload = {
      id: bookingAsset.id,
      bookingStatus: event.target.value,
      bookingId: fullBookingObj.id
    }
    dispatch(bookingService.updateBookingAsset(payload));
  }

  const fields: FormFieldType[] = [{
    id: 'amount',
    name: 'amount',
    type: 'integer_only',
    label: 'Refund Amount',
    validations: {
      required: true,
      maxLength: 20
    }
  },
  {
    id: 'paymentMethod',
    name: 'paymentMethod',
    type: 'select',
    options: PAYMENT_METHOD,
    defaultValue: PAYMENT_METHOD[0].id,
    itemLabelKey: 'name',
    itemValueKey: 'id',
    label: 'refund Payment Method',
    validations: {
      required: true,
      maxLength: 20
    },
  }];

  const columns: GridColDef[] = [
    {
      field: ' ',
      headerName: ' ',
      sortable: false,
      type: 'string',
      flex: 0.1
    },
    {
      field: 'name',
      headerName: t('name'),
      sortable: false,
      flex: 2,
      valueGetter: (params) => {
        return params?.row?.asset?.name || '';
      }
    },
    {
      field: 'code',
      headerName: t('booking.code'),
      filterable: false,
      flex: 0.75,
      valueGetter: (params) => {
        return params?.row?.asset?.code || '';
      }
    },
    {
      field: 'deliveryDate',
      headerName: t('booking.deliverydate'),
      filterable: false,
      flex: 1.2,
      valueGetter: (params) => {
        if (params?.row?.deliveryDate) {
          const date: Date = new Date(params?.row?.deliveryDate);
          return `${date.toLocaleString('en-GB', { hour12: true }) || ''}`;
        }
        return '';
      }
    },
    {
      field: 'returnDate',
      headerName: t('booking.returndate'),
      filterable: false,
      flex: 1.2,
      valueGetter: (params) => {
        if (params?.row?.returnDate) {
          const date: Date = new Date(params?.row?.returnDate);
          return `${date.toLocaleString('en-GB', { hour12: true }) || ''}`;
        }
        return '';
      }
    },
    {
      field: 'bookingStatus',
      headerName: t('booking.bookingstatus'),
      sortable: true,
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <Select
            fullWidth
            variant='standard'
            label={``}
            defaultValue={params?.row?.bookingStatus || BookingStatus[0]?.id}
            //value={params?.row?.bookingStatus || BookingStatus[0]?.id}
            options={BookingStatus || []}
            itemValue={`id`}
            itemText={`name`}
            onChange={(event) => handleOnStatusChange(event, params.row)}
          ></Select>
        )
      }
    }
  ];

  const findDefaultData = async () => {
    if (!selectedBokingData) {
      navigate(`${ROUTES.BOOKING_MANAGEMENT}`);
      return;
    }
    const id = selectedBokingData.id;
    setBookingId(id);
  };

  const updatePenidngRent = async (event) => {
    setPendingRent(event.target.value);
  };

  const updatePenidngRentPaymentType = async (event) => {
    setPendingRentPaymentType(event.target.value);
  };

  const updateDepositeAmount = async (event) => {
    setDepositeAmount(event.target.value);
  };

  const updateDepositeAmountPaymentMethod = async (event) => {
    setDepositeAmountPaymentMethod(event.target.value);
  };

  const collectAmount = (type: string) => {
    if (type === 'rent') {
      const payload = {
        amount: pendingRent,
        paymentMethod: pendingRentPaymentType,
        bookingId: fullBookingObj.id
      }
      dispatch(bookingService.collectRent(payload));
    } else if (type === 'deposite' || type === 'deposite-return') {
      const payload = {
        status: type === 'deposite' ? DepositeStatus.RECEIVE : DepositeStatus.RETURN,
        bookingId: fullBookingObj.id,
        amount: depositeAmount,
        paymentMethod: depositeAmountPaymentMethod
      }
      dispatch(bookingService.depositeUpdate(payload));
    } else {
    }
  };

  const cancelBookingHandler = (values: any) => {
    const payload = { ...values, bookingId: fullBookingObj.id };
    dispatch(bookingService.cancelBooking(payload));
  };

  useEffect(() => {
    if (bookingId) {
      dispatch(bookingService.setSelectedBooking(null));
      dispatch(bookingService.findBookingById(bookingId));
    }
  }, [bookingId]);

  useEffect(() => {
    setFullBookingObj(booking);
    setInitialHeaderDetail(
      VIEW_TYPE.BOOKING_MANAGEMENT,
      `${t('booking.bookingmanagement')} ${booking?.billNo}`,
      `${t('booking.list-all-booking-label')} ${selectedOrganization.tenantName}`,
      getBreadcrumbs(VIEW_TYPE.BOOKING_MANAGEMENT)
    );
    const pendingRent = booking?.rent - booking?.advance;
    setIsRentButtonDisabled(pendingRent === 0);
    setPendingRent(pendingRent);
  }, [booking]);

  useEffect(() => {
    if (!selectedBokingData && !bookingId) {
      navigate(`${ROUTES.BOOKING_MANAGEMENT}`);
    }
  }, [selectedBokingData]);

  function setInitialHeaderDetail(
    viewType,
    breadcrumbsHeading,
    subtitle,
    breadcrumbs
  ) {
    setViewType(viewType);
    setBreadcrumbsHeading(breadcrumbsHeading);
    setBreadcrumbs(breadcrumbs);
    setHeaderSubtitle(subtitle);
  }

  useEffect(() => {
    setInitialHeaderDetail(
      VIEW_TYPE.BOOKING_MANAGEMENT,
      `${t('booking.bookingmanagement')} ${fullBookingObj?.billNo}`,
      `${t('booking.list-all-booking-label')} ${selectedOrganization.tenantName}`,
      getBreadcrumbs(VIEW_TYPE.BOOKING_MANAGEMENT)
    );
  }, [location]);

  const getBreadcrumbs = (viewType) => {
    const breadcrumbs = [
      {
        name: t('organization'),
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: selectedOrganization.tenantName,
        route: ROUTES.USER_MANAGEMENT
      },
      {
        name: `Booking`,
        route: `${ROUTES.BOOKING_MANAGEMENT}`
      }
    ];
    return breadcrumbs;
  };

  useEffect(() => {
    setBookingList(bookingData);
  }, [bookingData]);

  const contentToPrint = useRef(null);
  const handlePrintButtonClick = useReactToPrint({
    documentTitle: "Booking Details",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
  })

  const handleFilterUsers = (value: string) => {
    const filteredBookigData = bookingData.filter(function (item) {
      return item.name.toLowerCase().includes(value.toLowerCase());
    });
    setBookingList(filteredBookigData);
  };

  const handleViewOrientation = (
    _event: MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    margin: theme.spacing(1.5),
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  }));

  var sectionStyle = {
    //2480 x 3508
    //paddingTop: `140px`,
    width: `24.0cm`,
    height: `29.7cm`,
    //backgroundRepeat: `no-repeat`,
    //backgroundSize: `100% 100%`,
    //backgroundImage: `url(${backgroundImg})`

    border: "solid",
    color: "#800042",
  };

  var detailStyle = {
    marginTop: "50px",
    marginLeft: "25px",
    marginRight: "30px"
  };

  return (
    <>
      <Helmet>
        <title>Bookingdlite - Booking View</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          breadcrumbs={breadcrumbs}
          heading={breadcrumbsHeading}
          subHeading={headerSubtitle}
        >
          {viewType == VIEW_TYPE.BOOKING_MANAGEMENT && (
            <Button
              size={'small'}
              sx={{ pt: 1, pb: 1 }}
              className="letter-spacing"
              variant={'contained'}
              btnText={t('booking.print')}
              startIcon={<AddTwoToneIcon fontSize="small" />}
              onClick=
              {() => {
                handlePrintButtonClick(null, () => contentToPrint.current);
              }}
            >
              {t('print')}
            </Button>
          )}
          <TextField
            size={'small'}
            id="outlined-search"
            label={t('booking.search-booking-label')}
            type="search"
            onChange={(e) => handleFilterUsers(e.target.value)}
          />
        </PageHeader>
      </PageTitleWrapper>
      <Container maxWidth="lg" >
        {viewMode === VIEW_TYPE.VIEW_BOOKING && (
          <>
            <Grid container spacing={3} sx={{ mt: 1, mb: 1 }}>
              <Grid xs={12} sm={12} md={4} lg={4} sx={{ pl: 1, pr: 1 }} spacing={2}>
                <Card>
                  <CardContent>
                    <Typography color={fullBookingObj?.bookingStatus === 'CANCELLED' ? "error.main" : "text.secondary"} variant="h5" gutterBottom>
                      {t('booking.status')} : {fullBookingObj?.bookingStatus}<br />
                    </Typography>
                    <Typography color="text.secondary" variant="h5" gutterBottom>
                      {t('booking.bookingid')}    : {fullBookingObj?.billNo}<br />
                      {t('booking.rent')}         : {fullBookingObj?.rent || ''}<br />
                      {t('booking.advance')}      : {fullBookingObj?.advance}<br />
                      {t('booking.deposite')}     : {fullBookingObj?.depositeAmount || 0}<br />
                      {t('booking.balancerent')}  : {fullBookingObj?.rent - fullBookingObj?.advance}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid xs={12} sm={12} md={4} lg={4} sx={{ pl: 1, pr: 1 }}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography color="text.secondary" variant="h5" gutterBottom>
                          Balance rent due: {fullBookingObj?.rent - fullBookingObj?.advance}
                        </Typography>
                      </Grid>

                      {!isRentButtonDisabled && fullBookingObj?.bookingStatus !== 'CANCELLED' ?
                        <>
                          <Grid item xs={6} sm={6} md={5} lg={5}>
                            <TextField size='small' value={pendingRent} onChange={updatePenidngRent}></TextField>
                          </Grid>
                          <Grid item xs={6} sm={6} md={5} lg={5}>
                            <Select size='small' value={pendingRentPaymentType}
                              onChange={updatePenidngRentPaymentType} options={PAYMENT_METHOD}
                              itemText='name' itemValue='id'
                              label="payment method" variant='standard'></Select>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Button size={'small'}
                              sx={{ pt: 1, pb: 1 }}
                              className="letter-spacing"
                              variant={'contained'} btnText='Collect Now'
                              onClick={() => { collectAmount('rent') }} />
                          </Grid>
                        </> : <></>}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid xs={12} sm={12} md={4} lg={4} sx={{ pl: 1, pr: 1 }}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography color="text.secondary" variant="h5" gutterBottom>
                          Deposite: {`${fullBookingObj?.depositeAmount || 0} (${fullBookingObj?.depositeStatus})`}
                        </Typography>
                      </Grid>
                      {(fullBookingObj?.depositeAmount !== null && fullBookingObj?.depositeAmount !== 0) && fullBookingObj?.depositeStatus !== Status.RETURN && fullBookingObj?.bookingStatus !== 'CANCELLED' ?
                        <>
                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField value={depositeAmount} onChange={updateDepositeAmount}></TextField>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Select value={depositeAmountPaymentMethod} onChange={updateDepositeAmountPaymentMethod}
                              options={PAYMENT_METHOD}
                              itemText='name' itemValue='id'
                              label="payment method" variant='standard'></Select>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={6}>


                            {fullBookingObj?.depositeStatus === Status.PENDING
                              ? <Button size={'small'}
                                sx={{ pt: 1, pb: 1 }}
                                className="letter-spacing"
                                variant={'contained'} btnText='Collect Now'
                                onClick={() => { collectAmount('deposite') }} />
                              : <></>
                            }
                            {fullBookingObj?.depositeStatus === Status.RECEIVE
                              ? <>
                                <Button size={'small'}
                                  sx={{ pt: 1, pb: 1 }}
                                  className="letter-spacing"
                                  variant={'contained'}
                                  btnText='Return Now'
                                  onClick={() => { collectAmount('deposite-return') }} />
                              </>
                              : <></>
                            }
                          </Grid>
                        </> : <></>}
                      {fullBookingObj?.bookingStatus !== 'CANCELLED' && (
                        <>
                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Button size={'small'}
                              sx={{ pt: 1, pb: 1 }}
                              className="letter-spacing"
                              variant={'contained'}
                              btnText='Cancel Booking'
                              onClick={() => {
                                setViewMode(VIEW_TYPE.CANCEL_BOOKING);
                              }} />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Button size={'small'}
                              sx={{ pt: 1, pb: 1 }}
                              className="letter-spacing"
                              variant={'contained'}
                              btnText='Edit Booking'
                              onClick={() => {
                                setViewMode(VIEW_TYPE.EDIT_BOOKING);
                              }} />
                          </Grid>
                        </>)}
                    </Grid>
                  </CardContent>
                </Card>  
              </Grid>
            </Grid>

            <Card className="mb-30">

              <Tables
                rows={fullBookingObj?.bookingAssets || []}
                columns={columns}
                checkboxSelection={false}
              />
            </Card>
            <div className="print-box">
              <div className="invoice-box" style={sectionStyle} ref={contentToPrint}>
                <table cellPadding="0" cellSpacing="0" style={{fontSize:"25px",}}>

                  <tr className="top">
                    <td colSpan={0}>
                      <table>
                        <tr>
                          <td className="title">
                            {/* <img
										src="https://sparksuite.github.io/simple-html-invoice-template/images/logo.png"
                    style={{ width: '100%', maxWidth: '300px' }}
									/> */}
                            {selectedOrganization.tenantName}
                          </td>

                          <td>
                            
                            {/* Mobile: {selectedOrganization?.mobile}<br /> */}
                            {/* Gst: {selectedOrganization?.gst}<br /> */}
                            
                          </td>
                          
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr className="information">
                    <td colSpan={2}>
                      <table>
                        <tr>
                          <td>
                            Name: {fullBookingObj?.name}<br />
                            Reference: {fullBookingObj?.reference}<br />
                            Address: {fullBookingObj?.address} <br />
                            remark:{fullBookingObj?.remark}<br /><br />
                            Rent: {fullBookingObj?.rent}<br />
                            Advance: {fullBookingObj?.advance}<br />
                            {fullBookingObj?.depositeAmount ? 'Deposite : ' : ''} {fullBookingObj?.depositeAmount}
                          </td>
                          <td>
                            Bill No: {fullBookingObj?.billNo}<br /><br />
                            Mobile: {fullBookingObj?.mobile}<br /><br />
                            Booking Date: {new Date(fullBookingObj?.bookingDate).toLocaleDateString('en-GB', { hour12: true }) || ''}<br />
                            {/* Booking Time: {new Date(fullBookingObj?.bookingDate).toLocaleTimeString('en-GB', { hour12: true }) || ''} */}
                          </td>
                          
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <Table size="small" aria-label="a dense table" style={{ fontSize: "25px", }}  >
                  <TableHead >
                    <TableRow>
                      <TableCell style={{ fontSize: "18px" }} >#</TableCell>
                      <TableCell style={{ fontSize: "20px" }} align="right">Item</TableCell>
                      <TableCell style={{ fontSize: "20px" }} align="right">Delivery Date</TableCell>
                      <TableCell style={{ fontSize: "20px" }} align="right">Return Date</TableCell>
                      <TableCell style={{ fontSize: "20px" }} align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ fontSize: "25px", }}>
                    {fullBookingObj?.bookingAssets?.map((bookingAsset, index) => (
                      <TableRow
                        key={bookingAsset.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{fontSize:"25px"}}>
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ fontSize: "25px" }} align="right">{bookingAsset?.asset?.name} - {bookingAsset?.asset?.code}</TableCell>
                        <TableCell style={{ fontSize: "25px" }} align="right">{new Date(bookingAsset?.deliveryDate).toLocaleString('en-GB', { hour12: true }) || ''}</TableCell>
                        <TableCell style={{ fontSize: "25px" }} align="right">{new Date(bookingAsset?.returnDate).toLocaleString('en-GB', { hour12: true }) || ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {/* <div className="a4-footer">સુચના : (૧) કોઇપણ પીસ લેવા આવો ત્યારે ભાડુ ડિપોઝીટ ફરજીયાત સાથે લાવવાની રહેશે. (ર) અમારા કોઇપણ પીસમાં ડાઘ અથવા ડેમેઝ થશે તો તેનો એકસ્ટ્રા ચાર્જ ચુકવવાનો રહેશે.(૩) બુકિંગ કરાવેલ પીસ કેન્સલ કરવા પર કોઇપણ સંજાગોમાં એડવાન્સ પરત મળશે નહી. (૪) કદાચ કોઇપણ સંજોગોમાં તમે સિલેકટ કરેલ પીસ અમે ના આપીશ શકીએ તો એના બદલ બીજો પીસ સિવકારવો પડશે.
                </div> */}
              </div>
            </div>
          </>
        )}
        {viewMode === VIEW_TYPE.CANCEL_BOOKING && (<>
          <Card className="mb-24">
            {' '}
            <Typography sx={{ p: 3, pl: 2 }} variant="h4" fontWeight="bold">
              {t('booking.cancel-booking')}
            </Typography>
            <Box sx={{ p: 1 }}>
              <CustomForm
                formFields={fields}
                enableReinitialize={true}
                initialValues={initialValues}
                submitBtnHandler={cancelBookingHandler}
                cancelBtnHandler={() => {
                  setViewMode(VIEW_TYPE.VIEW_BOOKING);
                }}
                resetOnSubmit={false}
              />
            </Box>
          </Card>
        </>)}
        {viewMode === VIEW_TYPE.EDIT_BOOKING && (<>
          <CustomForm
            formFields={fields}
            enableReinitialize={true}
            initialValues={initialValues}
            submitBtnHandler={cancelBookingHandler}
            cancelBtnHandler={() => {
              setViewMode(VIEW_TYPE.VIEW_BOOKING);
            }}
            resetOnSubmit={false}
          />
          <br></br>
          <Button size={'small'}
            sx={{ pt: 1, pb: 1 }}
            className="letter-spacing"
            variant={'contained'}
            btnText='View Booking details'
            onClick={() => {
              setViewMode(VIEW_TYPE.VIEW_BOOKING);
            }} /></>)}
      </Container>

    </>
  );
};

export default BookingDetails;
